import { render, staticRenderFns } from "./LastUpdatedAt.vue?vue&type=template&id=31e0da74&scoped=true&"
import script from "./LastUpdatedAt.vue?vue&type=script&lang=js&"
export * from "./LastUpdatedAt.vue?vue&type=script&lang=js&"
import style0 from "./LastUpdatedAt.vue?vue&type=style&index=0&id=31e0da74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0da74",
  null
  
)

export default component.exports